import { COMPANY } from '../constants/action-types'
import { CompanyDetails } from '../Actions'

type State = {
  data: CompanyDetails | null
  isLoading: boolean
  error: string | null
}

const initialState: State = {
  data: null,
  isLoading: false,
  error: null,
}

const companyDetailsReducer = (state = initialState, action: any): State => {
  switch (action.type) {
    case COMPANY.COMPANY_DETAILS_REQUEST:
      return { ...state, isLoading: true, error: null }
    case COMPANY.COMPANY_DETAILS_SUCCESS:
      return { ...state, isLoading: false, data: action.payload }
    case COMPANY.COMPANY_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: action.payload }
    default:
      return state
  }
}

export default companyDetailsReducer
